import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  iconfont: 'md',
})

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#2f7d74',
        secondary: '#2c3a3a',
        accent: '#3ba8a2',
        info: '#2f7d74',
        success: '#2e7d32',
        warning: '#ed6c02',
        error: '#c62828',
      },
    },
  },
});
